import React from 'react';
import classNames from './style.module.scss';

import { concatClassNames } from '../../../../utils/utilities';

const PAUTConstraint: React.FC = () => {
	return (
        <div className={classNames.pautConstraint}>
            <div className={concatClassNames([classNames.pautConstraint, classNames.pautConstraintFullHeight])}>
                <p>Access Restrictions / Constrain</p>
            </div>
        </div>
    );
};

export default PAUTConstraint;
